export {
  dynamicRulesListScreen,
  dynamicRuleDetailScreen,
  dynamicRulesSimulateScreen,
} from './dynamic-rules.screen';
export { dynamicRulesSearch, dynamicRuleDetailSearch } from './dynamic-rules.search';
export { loadDynamicRulesMessages } from './dynamic-rules.catalog';
export const loadDynamicRulesScreens = () => import('./screens');

/** Os guias das telas para o Luy (U46), sob demanda. */
export const loadDynamicRulesGuides = () => import('./dynamic-rules.guide');
